import {createApp} from "vue";
import {createPinia} from "pinia";
import "vuetify/styles";
import {createI18n} from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import en from "@/locales/en.json";
import vuetify from "./plugins/vuetify";
import initSentry from "./lib/sentry";
import {useGlobalStore} from "@/store";
import {loadAppConfiguration} from "@/lib/appConfiguration";
import {AppConfiguration} from "@YenzaCT/sdk";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";
import VueGtag from "vue-gtag";

loadAppConfiguration().then((appConfiguration: AppConfiguration) => {
  const pinia = createPinia();

  const i18n = createI18n({
    locale: "en",
    fallbackLocale: "en",
    legacy: false,
    globalInjection: true,
    messages: {
      en,
    }
  });

  const app = createApp(App);

  initSentry(app, router);

  app.use(pinia);
  const store = useGlobalStore();
  store.appConfiguration = appConfiguration;

  if (store.appConfiguration.integrations.dataDashAppGoogleAnalyticsCode)
    app.use(VueGtag, {
      config: { id: store.appConfiguration.integrations.dataDashAppGoogleAnalyticsCode }
    });

  app.use(router);
  app.use(i18n);
  app.use(vuetify(appConfiguration.themeLight || {}, appConfiguration.themeDark || {}));

  app.component("VueDatePicker", VueDatePicker);
  app.component("VueTelInput", VueTelInput);

  app.mount("#app");
}).catch((e) => {
  document.writeln("Failed to load app configuration. Please try again.");
  // eslint-disable-next-line no-console
  console.error(e);
});
